import IntlMessage, {
    IntlMessageValue
} from '../../../../../@WUM/core/component/const/IntlMessage'
import React from 'react'
import SunEditorBig from '../../../../../@WUM/core/component/const/SunEditorBig'
import { SunEditorConfig } from '../../../../../@WUM/core/component/const/SunEditorConfig'

function configuration(
    conf: string,
    response: any,
    newElement: any = false,
    Store: any
) {
    let cutDate =
        newElement === false
            ? response.datum !== undefined && response.datum !== null
                ? response.datum.split(' ')[0]
                : ' '
            : ' '

    const titel = (
        <>
            <h2>
                <IntlMessage
                    messageId="configuration.home.title"
                    Store={Store}
                />
            </h2>
        </>
    )

    const description = (
        <>
            <p>
                <IntlMessage
                    messageId="configuration.home.description"
                    Store={Store}
                />
            </p>
        </>
    )

    const dataColOne = [
        {
            formType: 'input',
            type: 'hidden',
            name: 'discr',
            value: newElement === false ? response.discr : ''
        },
        {
            formType: 'input',
            type: 'hidden',
            name: 'layout',
            value: newElement === false ? response.layout : ''
        },
        {
            formType: 'input',
            label: <IntlMessage messageId="common.title" Store={Store} />,
            required: true,
            type: 'text',
            name: 'titel',
            value: newElement === false ? response.titel : ''
        },
        {
            formType: 'input',
            label: <IntlMessage messageId="common.date" Store={Store} />,
            type: 'date',
            name: 'datum',
            format: 'en',
            nowFormat: 'en',
            placeholder: 'xx.xx.xxxx',
            value: cutDate
        },

        SunEditorBig(
            response,
            'content',
            newElement,
            { lang: 'de', height: '350px;', config: SunEditorConfig() },
            'content',
            'content',
            '',
            '',
            '',
            '',
            'classic',
            '200'
        )
    ]

    const dataColtwo = [
        {
            formType: 'multiply',
            cols: [
                {
                    formType: 'image',
                    altLink: true,
                    id: 'image_title_image_',
                    path:
                        newElement === false
                            ? response.image !== null
                                ? response.image !== undefined
                                    ? response.image.cdn_url
                                    : ''
                                : ''
                            : '',
                    width: '44',
                    height: '44',
                    class: 'elementsIMg',
                    size: {
                        xl: 12,
                        md: 12,
                        sm: 12
                    }
                },
                {
                    formType: 'formFile',
                    onclick: true,
                    onclick_context: 'pielers_element_text_image',
                    append: 'image_id',
                    src: 'image_title_image_',
                    experiment: true,
                    size: {
                        xl: 12,
                        md: 12,
                        sm: 12
                    }
                }
            ]
        },
        {
            formType: 'input',
            name: 'mediaId',
            id: 'image_id',
            visible: true,
            type: 'hidden',
            placeholder: 'imageID',
            value:
                newElement === false
                    ? response.mediaId !== null
                        ? response.mediaId !== undefined
                            ? response.mediaId
                            : null
                        : null
                    : null
        },

        {
            formType: 'select',
            label: <IntlMessage Store={Store} messageId="common.visible" />,
            name: 'visible',
            selected: newElement === false ? response.visible : 0,
            options: [
                {
                    label: IntlMessageValue('de', 'common.activated', Store),
                    value: '1'
                },
                {
                    label: IntlMessageValue('de', 'common.deactivated', Store),
                    value: '0'
                }
            ]
        }
    ]

    if (conf === 'titel') {
        return titel
    } else if (conf === 'description') {
        return description
    } else if (conf === 'dataColOne') {
        return dataColOne
    } else if (conf === 'dataColtwo') {
        return dataColtwo
    }
}

export default configuration
